/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function findItemIndex(_ref) {
  var id = _ref.id,
    data = _ref.data,
    getIdProperty = _ref.getIdProperty;
  if (!Array.isArray(data) || !getIdProperty || id == null) {
    return null;
  }
  var filteredList = data.reduce(function (acc, item, index) {
    if (getIdProperty(item) === id) {
      acc = index;
    }
    return acc;
  }, null);
  return filteredList !== null ? filteredList : null;
}
var _default = findItemIndex;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/findItemIndex.js
// module id = 242
// module chunks = 0